import { useEffect } from 'react';

/**
 * Mirrors an unread count onto the installed app's icon (Badging API). Silent
 * where the API is missing or refuses: a plain browser tab has no icon to badge.
 * Pass undefined while the count is still loading so nothing is cleared early.
 */
export function useAppBadge(count: number | undefined): void {
  useEffect(() => {
    if (count === undefined) return;
    if (!('setAppBadge' in navigator) || !('clearAppBadge' in navigator)) return;
    const call = count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge();
    call.catch(() => undefined);
  }, [count]);
}
